// @ts-nocheck

import { useEffect, useState } from "react";
import ReactECharts from "echarts-for-react";
import useStoreTimToa from "../../../store/useStoreTimToa";
import { Icons } from "../../spinner";
import { Info } from "@phosphor-icons/react";

export function PriorityByTime() {
  const [options, setOptions] = useState({});
  const { priorityByTimeData, loadingChartPriorityByTime } = useStoreTimToa(
    (state) => state
  );

  const transformData = (data) => {
    if (!data) return null;

    const timePoints = [
      "10m",
      "30m",
      "1h",
      "2h",
      "3h",
      "4h",
      "5h",
      "6h",
      "7h",
      "8h",
      ">8h",
    ];
    const priorities = ["P1", "P2", "P3", "P4", "P5", "N/A"];

    return priorities.map((priority) => ({
      name: priority,
      type: "line",
      stack: "Total",
      data: timePoints.map((time) => data.prioridades[priority][time]),
    }));
  };

  useEffect(() => {
    if (priorityByTimeData) {
      const series = transformData(priorityByTimeData);

      const options = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["P1", "P2", "P3", "P4", "P5", "N/A"],
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: ["10m", "30m", "1h", "2h", "3h", "4h", "5h", "6h", "7h", "8h", ">8h"],
          axisLabel: {
            color: "#fff",
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#fff",
          },
        },
        series,
      };

      setOptions(options);
    }
  }, [priorityByTimeData]);

  return (
    <>
      {priorityByTimeData ? (
        <div className="bg-gray-500 shadow-md rounded-sm col-span-2">
          <ReactECharts option={options} style={{ height: "450px", width: "100%" }} />
        </div>
      ) : loadingChartPriorityByTime ? (
        <div className="h-[450px] bg-gray-500 flex justify-center items-center rounded-sm col-span-2">
          <Icons.spinner className="h-12 w-12 animate-spin text-orange-300" />
        </div>
      ) : (
        <div className="h-[450px] bg-gray-500 flex justify-center items-center rounded-sm col-span-2">
          <p className="bg-slate-100 p-2 text-gray-500 rounded-md font-extrabold">
            SEM DADOS
          </p>
        </div>
      )}
    </>
  );
}
